// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6 4.75H4.75C2.96 4.75 1.5 6.21 1.5 8C1.5 9.79 2.96 11.25 4.75 11.25H6',
  'M10 4.75H11.25C13.04 4.75 14.5 6.21 14.5 8C14.5 9.79 13.04 11.25 11.25 11.25H10',
  'M5.5 8H10.5',
];
